<template>
  <article
    class="teaser-event"
    :style="
      extension.flag?.color
        ? `--flag-color: ${extension.flag?.color}`
        : undefined
    "
  >
    <div
      v-click-redirect="{ configPreset: 'teaser-default' }"
      class="teaser-event__content"
    >
      <time class="teaser-event__date-rows date-rows" :datetime="datetime">
        <span class="date-rows__date">{{ date }}</span>
        <span class="date-rows__weekday">{{ weekday }}</span>
        <span class="date-rows__time">{{ time }}</span>
      </time>

      <header class="teaser-event__header">
        <div class="teaser-event__label-tag label-tag">
          <span> {{ extension.label }} </span>
        </div>
        <h3 class="teaser-event__heading">
          <r-link
            class="teaser-event__link"
            :url="teaser.link.url"
            :target="teaser.link.target"
          >
            {{ title }}
          </r-link>
        </h3>
      </header>
    </div>

    <figure
      class="teaser-event__figure"
      :class="{
        'calendar-event__figure--has-flag': extension.flag?.color,
      }"
    >
      <r-image
        class="teaser-event__picture"
        :sources="teaser.image.sources"
        :alt="teaser.image.alt"
      />
    </figure>
  </article>
</template>

<script setup>
import {
  useExtension,
  useExtensionDate,
} from '@components/organisms/api/extensions/use-extension.composable.js';
import { toRefs, inject, ref } from 'vue';

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const { data } = toRefs(props);

const { teaser, extension, title } = useExtension({ data });

const { date, time, weekday, datetime } = useExtensionDate({ data });
</script>
